(function () {
  var READY_ATTR = 'data-card-swipe-ready';
  var SWIPE_THRESHOLD = 30;
  var INTENT_THRESHOLD = 8;
  var TRANSITION_MS = 300;
  var TRANSITION = 'transform ' + TRANSITION_MS + 'ms ease';
  var SNAP_FALLBACK_MS = TRANSITION_MS + 60;
  var CLICK_SUPPRESS_MS = 350;
  var SUPPORTS_POINTER = typeof window !== 'undefined' && 'PointerEvent' in window;

  function initGallery(gallery) {
    if (gallery.hasAttribute(READY_ATTR)) return;
    gallery.setAttribute(READY_ATTR, '');

    var track = gallery.querySelector('[data-card-swipe-track]');
    if (!track) return;

    var originalSlides = track.querySelectorAll('.card-swipe__slide');
    var dots = gallery.querySelectorAll('.card-swipe__dot');
    var total = originalSlides.length;
    if (total < 2 || dots.length !== total) return;

    var firstClone = originalSlides[0].cloneNode(true);
    var lastClone = originalSlides[total - 1].cloneNode(true);
    firstClone.setAttribute('aria-hidden', 'true');
    lastClone.setAttribute('aria-hidden', 'true');
    firstClone.removeAttribute('aria-label');
    lastClone.removeAttribute('aria-label');
    track.insertBefore(lastClone, originalSlides[0]);
    track.appendChild(firstClone);

    var lastVisual = total + 1;
    var visualIndex = 1;
    var startX = 0;
    var startY = 0;
    var dragX = 0;
    var dragging = false;
    var axis = null;
    var suppressClickUntil = 0;
    var snapPending = false;
    var snapTimer = null;
    var activePointerId = null;

    function setTransform(percent, withTransition) {
      track.style.transition = withTransition ? TRANSITION : 'none';
      track.style.transform = 'translateX(' + percent + '%)';
    }

    function realIndex() {
      if (visualIndex === 0) return total - 1;
      if (visualIndex === lastVisual) return 0;
      return visualIndex - 1;
    }

    function updateDots() {
      var idx = realIndex();
      for (var d = 0; d < dots.length; d++) {
        if (d === idx) {
          dots[d].classList.add('is-active');
        } else {
          dots[d].classList.remove('is-active');
        }
      }
    }

    function jumpToReal() {
      if (visualIndex === 0) {
        visualIndex = total;
      } else if (visualIndex === lastVisual) {
        visualIndex = 1;
      } else {
        return;
      }
      track.style.transition = 'none';
      track.style.transform = 'translateX(' + (-visualIndex * 100) + '%)';
      void track.offsetHeight;
    }

    function clearSnapTimer() {
      if (snapTimer) {
        clearTimeout(snapTimer);
        snapTimer = null;
      }
    }

    function scheduleSnap() {
      clearSnapTimer();
      snapPending = true;
      snapTimer = setTimeout(function () {
        snapTimer = null;
        if (!snapPending) return;
        snapPending = false;
        jumpToReal();
      }, SNAP_FALLBACK_MS);
    }

    function onTransitionEnd(e) {
      if (e.target !== track) return;
      if (!snapPending) return;
      snapPending = false;
      clearSnapTimer();
      jumpToReal();
    }

    function goTo(newIndex, animate) {
      visualIndex = newIndex;
      setTransform(-visualIndex * 100, animate !== false);
      updateDots();
      if (animate !== false && (visualIndex === 0 || visualIndex === lastVisual)) {
        scheduleSnap();
      }
    }

    function ensureRealPosition() {
      if (snapPending || visualIndex === 0 || visualIndex === lastVisual) {
        snapPending = false;
        clearSnapTimer();
        jumpToReal();
      }
    }

    function onStart(clientX, clientY) {
      ensureRealPosition();
      startX = clientX;
      startY = clientY;
      dragX = 0;
      dragging = true;
      axis = null;
      setTransform(-visualIndex * 100, false);
    }

    function onMove(clientX, clientY, event) {
      if (!dragging) return;
      var dx = clientX - startX;
      var dy = clientY - startY;

      if (axis === null) {
        if (Math.abs(dx) > INTENT_THRESHOLD || Math.abs(dy) > INTENT_THRESHOLD) {
          axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        }
      }

      if (axis === 'x') {
        if (event && event.cancelable) event.preventDefault();
        dragX = dx;
        var base = -visualIndex * 100;
        var dragPercent = (dx / track.clientWidth) * 100;
        setTransform(base + dragPercent, false);
      }
    }

    function onEnd() {
      if (!dragging) return;
      dragging = false;

      if (axis !== 'x') {
        goTo(visualIndex, true);
        return;
      }

      suppressClickUntil = Date.now() + CLICK_SUPPRESS_MS;

      if (Math.abs(dragX) > SWIPE_THRESHOLD) {
        goTo(visualIndex + (dragX < 0 ? 1 : -1), true);
      } else {
        goTo(visualIndex, true);
      }
    }

    if (SUPPORTS_POINTER) {
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        activePointerId = e.pointerId;
        if (track.setPointerCapture) {
          try { track.setPointerCapture(e.pointerId); } catch (err) {}
        }
        onStart(e.clientX, e.clientY);
        if (e.pointerType === 'mouse') {
          e.preventDefault();
        }
      });

      track.addEventListener('pointermove', function (e) {
        if (activePointerId !== null && e.pointerId !== activePointerId) return;
        onMove(e.clientX, e.clientY, e);
      });

      var release = function (e) {
        if (activePointerId !== null && e.pointerId !== activePointerId) return;
        activePointerId = null;
        onEnd();
      };
      track.addEventListener('pointerup', release);
      track.addEventListener('pointercancel', release);
    } else {
      track.addEventListener('touchstart', function (e) {
        var t = e.touches[0];
        onStart(t.clientX, t.clientY);
      }, { passive: true });

      track.addEventListener('touchmove', function (e) {
        var t = e.touches[0];
        onMove(t.clientX, t.clientY, e);
      }, { passive: false });

      track.addEventListener('touchend', onEnd);
      track.addEventListener('touchcancel', onEnd);
    }

    track.addEventListener('transitionend', onTransitionEnd);

    track.addEventListener('click', function (e) {
      var slide = e.target.closest && e.target.closest('.card-swipe__slide');
      if (!slide) return;
      if (Date.now() < suppressClickUntil) {
        e.preventDefault();
        e.stopPropagation();
      }
    });

    track.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    goTo(1, false);
  }

  function initAll(root) {
    var scope = root || document;
    var galleries = scope.querySelectorAll('[data-card-swipe]');
    for (var i = 0; i < galleries.length; i++) {
      initGallery(galleries[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
